<template>
  <div>
      <section class="xlrclh">
          <img class="top-img" src="./../assets/imgs/132/base.png" alt="" />
          <div class="technological-process">
              <div class="rhtj mar-t2">
                  <img
                      class="top"
                      src="./../assets/imgs/xllh/rcgyysq_zcjj.png"
                      alt=""
                  />
                  <div class="content">
                    为贯彻落实《成都市创建吸引和集聚人才平台激发人才创新创造活力的若干政策措施》（成委厅〔2022〕41号）和《成都市人才发展“十四五”规划》（成委办〔2022〕6号），围绕深入实施乡村振兴战略，加快打造农业科技创新主力军，从2023年起，市级层面每年遴选支持10名农业科技领军人才、20名优秀青年科技人才和10个左右高水平创新团队。
                  </div>
              </div>
              <div class="zccl" >
                  <img
                      class="top"
                      src="./../assets/imgs/132/title1.png"
                      alt=""
                  />
                  <div class="content" style="background-color: #fff;">
                    重点围绕生物种业、耕地保育、智能装备、智慧农业、动植物疫病防控、减排固碳、绿色发展等事关粮食安全、生物安全、生态安全以及农业经济与农村发展等关键核心技术领域，支持一批引进到我市涉农企业、事业单位、科研机构、高等院校等单位的全职在岗科研人员。支持类别包括个人项目和团队项目，其中个人项目分为农业科技领军人才和优秀青年科技人才两类。
                  </div>
              </div>
              <div class="zccl">
                  <img
                      class="top"
                      src="./../assets/imgs/132/title2.png"
                      alt=""
                  />
                  <div class="content">
                      <div class="des">
                          <div class="title">一、农业科技领军人才</div>
                          <div >
                            对农业产业发展有突出贡献，具有前瞻开阔的战略思维，善于带领产学研协同攻关，联系农业产业发展实际紧密，在同行中具有公认的影响力。年龄在55周岁以下（特别优秀的可放宽到57周岁）。
                          </div>
                      </div>
                      <div class="des">
                          <div class="title">二、优秀青年科技人才</div>
                          <div >
                            科研工作对农业产业发展有潜在或较高的应用价值，在青年同行中出类拔萃，具有明显的领军潜力，主动服务农业产业发展。年龄在40周岁以下（特别优秀的可放宽到42周岁）。
                          </div>
                      </div>
                      <div class="des">
                          <div class="title">三、高水平创新团队</div>
                          <div >
                            符合我市“4+6”都市农业产业体系发展方向，有明确的研发转化目标，承担重大科研项目、重点工程、重点研发任务，拥有核心技术和自主知识产权，研发水平处于行业领域前列，具有较强的科技成果转化能力和产业化发展前景，能有效促进我市都市现代农业转型升级的高层次人才聚合体；所在区（市）县、企事业单位能从资金资助、创新支持等方面给予充分配套，为团队建设及技术开发创造良好条件。
                          </div>
                      </div>
                  </div>
              </div>

              <div class="gmlc">
                  <img
                      class="top"
                      src="./../assets/imgs/132/title3.png"
                      alt=""
                  />
                  <div class="content">
                      <div class="des mar-t3">
                          <div class="line-item">
                              <div class="line"></div>
                              <div class="line-top">
                                  <div class="line-num">1</div>
                                  <div class="line-title">制发申报通知</div>
                              </div>
                              <div class="line-content">
                                市农业农村局制发成都市农业科技英才培育项目申报通知，明确遴选工作的目标任务、申报条件、申报程序、时间进度和工作要求等。
                              </div>
                          </div>
                          <div class="line-item">
                              <div class="line"></div>
                              <div class="line-top">
                                  <div class="line-num">2</div>
                                  <div class="line-title">推荐申报</div>
                              </div>
                              <div class="line-content">
                                用人单位根据项目申报通知要求，按照属地管理原则，组织开展推荐申报工作。申报人选经用人单位审核并采取适当方式公示后报所在地区（市）县农业农村行政主管部门，审核通过后，进行为期5个工作日的公示，报送市农业农村局。用人单位、区（市）县农业农村行政主管部门对推荐人选和申报材料的真实性、准确性把关。
                              </div>
                          </div>

                          <div class="line-item">
                              <div class="line-top">
                                  <div class="line" style="height: 140%;"></div>
                                  <div class="line-num">3</div>
                                  <div class="line-title" style="text-wrap: nowrap;">评审</div>
                              </div>
                              <div class="line-content">市农业农村局对推荐人选进行资格审核后，组织专家评审委员会开展评审，提出建议名单提交局党组会议审议。</div>
                          </div>
                          <div class="line-item">
                              <div class="line-top">
                                  <div class="line-num">4</div>
                                  <div class="line-title">审定</div>
                              </div>
                              <div class="line-content">经市农业农村局党组会议审议通过后，由市农业农村局印发正式名单，落实资助政策。</div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="zccl" style="margin-top: 0.8rem;">
                  <img
                      class="top"
                      src="./../assets/imgs/132/title4.png"
                      alt=""
                  />
                  <div class="content" style="background-color: #fff;">
                    对农业科技领军人才给予每人10万元资助，对优秀青年科技人才给予每人5万元资助，对高水平创新团队给予每个团队20万元资助。
                  </div>
              </div>
              <div class="zccl">
                  <img
                      class="top"
                      src="./../assets/imgs/132/title5.png"
                      alt=""
                  />
                  <div class="content" style="background-color: #fff;font-weight: bolder;">
                    按相关通知要求进行。
                  </div>
              </div>
              <div class="contact" style="margin-top: 0.3rem">
                  <img
                      class="top"
                      src="./../assets/imgs/132/title6.png"
                      alt=""
                  />
                  <div class="content">
                      <div class="number">
                          <span class="label">政策咨询电话：</span>
                          <div>
                              <a href="tel:028-61883525">028-61883525</a>
                          </div>
                      </div>
                      <div class="unit">
                          <span class="label">责任单位：</span>
                          成都市农业农村局
                      </div>
                  </div>
              </div>
              <!-- <div class="codes">
                  <img class="info" src="../assets/imgs/132/code.png" />
              </div> -->
          </div>
      </section>
      <call phone="028-61883525"></call>
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
      return {};
  },

  components: {
      call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;

  .top-img {
      width: 7.26rem;
      height: 5.6rem;
  }

  .technological-process {
      transform: translateY(-1.9rem);

      .rhtj {
          position: relative;

          .top {
              width: 6.86rem;
              height: 1.12rem;
          }

          .content {
              width: 6.85rem;
              margin: -0.45rem auto 0;
              padding: 0.33rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;
              background: #ffffff;
              font-size: 0.26rem;
              color: #4e4e4e;
              text-align: left;
              position: relative;
              font-weight: 500;
              line-height: 0.44rem;
          }
      }

      .zccl {
          position: relative;
          margin-top: 0.22rem;

          .top {
              width: 7.03rem;
              height: 1.37rem;
              margin-left: -0.18rem;
          }

          .content {
              width: 6.85rem;
              background: #e8eeff;
              margin: -0.45rem auto 0;
              padding: 0.33rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;
              padding-top: 0.28rem;
              font-size: 0.26rem;
              font-weight: 500;
              text-align: left;
              color: #4e4e4e;
              line-height: 0.44rem;

              .des {
                  color: #4e4e4e;
                  text-align: left;
                  background: #ffffff;
                  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                  padding: 0.35rem 0.23rem 0.3rem;
                  margin-top: 0.8rem;
                  position: relative;
                  text-align: left;

                  .title {
                      position: absolute;
                      top: -0.5rem;
                      left: 50%;
                      transform: translateX(-50%);
                      width: 3.92rem;
                      height: 0.67rem;
                      line-height: 0.67rem;
                      display: flex;
                      justify-content: center;
                      align-content: center;
                      font-size: 0.32rem;
                      font-weight: bold;
                      color: #ffffff;
                      border-radius: 1rem;
                      background-color: #739bfe;
                  }
              }
          }
      }

      .gmlc {
          position: relative;
          margin-top: 0.22rem;

          .top {
              width: 7.03rem;
              height: 1.37rem;
              margin-left: -0.18rem;
          }

          .content {
              width: 6.86rem;
              background: #e8eeff;
              margin: -0.55rem auto;
              padding: 0 0.33rem 0.35rem 0.36rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;

              .title {
                  font-size: 0.36rem;
                  font-weight: bold;
                  color: #333333;
                  text-align: left;
                  line-height: 0.5rem;
              }

              .des {
                  color: #4e4e4e;
                  text-align: left;
                  background: #ffffff;
                  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                  padding: 0.3rem 0.23rem;
                  font-size: 0.26rem;
                  font-weight: 500;
                  color: #4e4e4e;
                  line-height: 0.44rem;

                  .line-item {
                      font-size: 0.26rem;
                      position: relative;
                      z-index: 3;

                      .line {
                          position: absolute;
                          width: 0.02rem;
                          height: 130%;
                          border-left: 0.02rem dashed #739bfe;
                          left: 0.2rem;
                          z-index: 0;
                          //   background-color: #739bfe;
                      }

                      .line-title {
                          font-size: 0.3rem;
                          font-weight: bold;
                          color: #3d5aa3;
                      }

                      .line-top {
                          display: flex;
                          width: 4.4rem;
                          height: 0.55rem;
                          background-image: url(../assets/imgs/25/label.png);
                          background-size: 100% 100%;
                          z-index: 99;
                          display: flex;
                          align-items: center;
                          box-sizing: border-box;
                          padding-left: 0.1rem;

                          .line-num {
                              width: 0.44rem;
                              height: 0.44rem;
                              background: #fff;
                              color: #3d5aa3;
                              display: inline-flex;
                              border-radius: 50%;
                              justify-content: center;
                              align-items: center;
                              margin-right: 0.18rem;
                              position: relative;
                              z-index: 3;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                              font-size: 0.28rem;
                              font-weight: bold;
                          }
                      }

                      .line-content {
                          //   border-left: 0.02rem dashed #739bfe;
                          padding-bottom: 0.32rem;
                          margin-left: 0.2rem;
                          padding-left: 0.32rem;
                          padding-top: 0.15rem;
                          word-break: break-all;
                          line-height: 0.44rem;
                      }
                  }
              }
          }
      }

      .codes {
          margin: 0 auto;
          margin-top: 0.25rem;
          width: 6.85rem;
          background: #fff;
          padding: 0.3rem;
          box-sizing: border-box;
          border-radius: 0.26rem;
          padding-top: 0.28rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .info {
            width: 100%;
            height: 100%;
          }
      }
  }
}
</style>
